import { toast } from "react-toastify";

import { Button } from "@/components/ui/button";

export const successToast = (message: string, content?: string) => {
  toast.success(
    <div>
      <p className="text-base font-medium text-foreground">{message}</p>
      {content && (
        <p className="mt-1 text-sm font-normal text-muted-foreground">
          {content}
        </p>
      )}
    </div>
  );
};

interface ErrorToastOptions {
  /** Optional retry callback rendered as an inline button inside the toast. */
  onRetry?: () => void;
  /** Custom retry label (defaults to "Retry"). */
  retryLabel?: string;
}

export const errorToast = (
  message: string,
  content?: string,
  options?: ErrorToastOptions
) => {
  toast.error(
    <div>
      <p className="text-base font-medium text-foreground">{message}</p>
      {content && (
        <p className="mt-1 text-sm font-normal text-muted-foreground">
          {content}
        </p>
      )}
      {options?.onRetry && (
        <Button
          variant="link"
          size="none"
          onClick={options.onRetry}
          className="mt-2 h-auto p-0 text-sm font-medium text-primary underline hover:text-primary/80"
        >
          {options.retryLabel ?? "Retry"}
        </Button>
      )}
    </div>,
    { position: "top-right" }
  );
};
